import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";

export class AgentsViewSettingsPanelComponent implements IController {

  settings: any;
  onSettingsChange: Function;

  constructor(private $mdPanel, private splitService: SplitService) {

  }

  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.OFFSET_START,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.show-button')
      .withAnimation(this.$mdPanel.animation.FADE);

    const settingsRef = this.settings;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<agents-view-settings-panel-template ' +
        'panel-ref="ctrl.mdPanelRef" settings="ctrl.settings">' +
        '</agents-view-settings-panel-template>',
      controller: function () {
        this.settings = settingsRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, reason, updatedSettings) => {

        if (_.isEqual(reason, 'Submit')) {
          this.onSubmit(updatedSettings);
        }

        if (_.isEqual(reason, 'Reset')) {
          this.onReset();
        }

        if (_.isEqual(reason, 'Cancel')) {
          this.onReset();
        }

        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onClosePanel(settingsConfig) {
    this.onSettingsChange({
      settings: settingsConfig
    })
  }

  onSubmit(settings) {
    this.onSettingsChange({settings: settings});
  }

  onReset() {
    const settingsConfig = this.splitService.getSiteAgentsSettings(this.splitService.getSiteId());
    this.onSettingsChange({settings: settingsConfig});
  }

  onCancel() {
    this.onSettingsChange({settings: this.settings});
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentsViewSettingsPanel', {
    bindings: {
      settings: '<',
      onSettingsChange: '&'
    },
    template: require('./agents-view-settings-panel.html').default,
    controller: AgentsViewSettingsPanelComponent
  });
